



















































import { Component, Vue, Inject, Prop, Watch } from 'vue-property-decorator';
import Util from '@/lib/util';
import ListBase from '@/lib/listbase';
import PageRequest from '@/store/entities/page-request';
import ListView from '@/components/helper/list-view.vue';
import FormBase from '@/components/helper/form-base.vue';
import SaleForm from './sale-form.vue';
import ImportChanges from './import-changes.vue';
import DealerList from './dealer-list.vue';
import Indicators from './indicators.vue';

class PageSaleRequest extends PageRequest {
    year: any = parseInt(Util.abp.clock.today().substr(0, 4));
    month: any = parseInt(Util.abp.clock.today().substr(5, 2));
    dealer: number = null;
    red: number = null;
    process_type: number = null;
    vin: string = null;
    contact: string = null;
    type: number = null;
    date_from: string = '';
    date_to: string = '';
}

@Component({
    components: { ListView, SaleForm, FormBase, ImportChanges, DealerList, Indicators },
    watch: {
        dealers: function (val) {
            (this as any).getAll();
        },
        red: function (val) {
            (this as any).getAll();
        }
    }
})
export default class Sales extends ListBase {
    entity: string = 'sale';
    pagerequest: PageSaleRequest = new PageSaleRequest();
    filterForm: boolean = true;
    selProcess: number = Util.abp.list.get('PROCESS','PV').id;
    //selProcess: number = this.processList[0].id;
    showImport: boolean = false;
    showDealers: boolean = false;
    widType: string = 'Postventa';

    filterItems = [
        this.gItem({ type: 'select', prop: 'year', label: 'Anio', options: 'years', hideDetails: true, onchange: this.getAll, size: 1 }),
        this.gItem({ type: 'select', prop: 'month', label: 'Mes', options: 'months', hideDetails: true, onchange: this.changeMonth, size: 2 }),
        this.gItem({ type: 'spacer', size: 1 }),
        this.gItem({ type: 'date', prop: 'date_from', label: 'Desde', size: 1, hideDetails: true, onchange: this.getpage }),
        this.gItem({ type: 'date', prop: 'date_to', label: 'Hasta', size: 1, hideDetails: true, onchange: this.getpage }),
        //this.gItem({ type: 'object', prop: 'type', label: 'Tipo de Estudio', generalType: 'T_VEHICLE', hideDetails: true, onchange: this.getpage, size: 2 }),
        this.gItem({ type: 'text', prop: 'vin', label: 'Buscar por Vin', hideDetails: true, onchange: this.getpage, size: 2 }),
        //this.gItem({ type: 'text', prop: 'contact', label: 'Buscar por Contacto', hideDetails: true, onchange: this.getpage, size: 2 }),
        this.gItem({ type: 'spacer', size: 4 }),
    ]


    columns = [
        this.gCol('number', 'ID', 'text', '', false),
        this.gCol('service_date', 'FECHA TRANSACCION', 'date', '', false),
        this.gCol('dealer.fullname', 'DEALER', 'text', '', false),
        this.gCol('customer', 'FIRST NAME', 'text', '250px', false),
        this.gCol('email', 'EMAIL', 'text', '', false),
        this.gCol('lang', 'IDIOMA', 'text', '', false),
        this.gCol('country.name', 'PAIS', 'text', '', false),
        this.gCol('city', 'ASSOCIATE', 'text', '', false),
        this.gCol('assessor_name', 'SURVEY NAME', 'text', '200px', false),
        this.gCol('vin', 'VIN', 'text', '', false),
        this.gCol('service_type', 'Tipo Servicio', 'text', '150px', false),
        this.gCol('contact', 'FIRST CONTACT', 'text', '200px', false),
        this.gCol('address1', 'FORM OF ADDRESS', 'text', '350px', false),
        this.gCol('technician_name', 'LAST NAME', 'text', '200px', false),
        this.gCol('phone', 'Telefono Principal', 'text', '', false),
        this.gCol('model', 'BRAND', 'text', '150px', false),
        this.gCol('address2', 'CUSTOMER NUMBER', 'text', '150px', false),
        this.gCol('plate', 'AGE_GROUP', 'text', '', false),
        this.gCol('seller_name', 'CUSTOMER GENDER', 'text', '', false),
        this.gCol('postal_code', 'Codigo Postal', 'text', '', false),
        this.gCol('invoice', 'CLIENT SEGMENTATION', 'text', '', false),
        this.defaultActions('edit|delete')
    ]
    
    get process() {
        return Util.abp.list.getItem(this.selProcess);
    }
    get dealers() {
        return this.$store.state.app.dealers;
    }
    get red() {
        return this.$store.state.app.red;
    }
    get checking() {
        return this.$store.state.dashboard.loading;
    }
    get loading() {
        return this.$store.state.sale.loading;
    }
    get isDealer() {
        return Util.abp.session.isDealer();
    }
    get ttrLink() {
        return Util.abp.setting.get('TTR_LINK');
    }
    get monthDates() {
        let months = this.gCommonList('months');
        let dates = this.$store.state.auditlog.dates;
        let list = [];
        months.forEach(m => {
            let item = { month: m.id, dates: [] };
            item.dates.push(...dates.filter(a => { return a.month == m.id }).map(a => { return a.date }));
            if (item.dates.length > 0)
                list.push(item);
        });
        return list;
    }
    

    edit() {
        this.modalShow = !this.modalShow;
    }
    create() {
        this.modalShow = !this.modalShow;
    }
    
    openDealer(item) {
        this.widType = item.name;
        this.showDealers = true;
    }
            
    async loadDash() {
        this.loadDates();
        this.loadData();
    }

    async changeMonth() {
        this.getpage();
        this.loadData();
    }

    async getAll() {
        this.getpage();
        this.loadDates();
        this.loadData();
    }

    async getpage() {
        this.$store.commit('sale/setProcess', this.selProcess);
        let list: any = this.$refs.listView
        if (list != undefined) {
            this.pagerequest.dealer = this.dealers;
            this.pagerequest.red = this.red;
            this.pagerequest.process_type = this.selProcess;
            await list.getpage();
        }
    }

    async exportData() {
        this.pagerequest.dealer = this.dealers;
        this.pagerequest.red = this.red;
        let filename = await this.$store.dispatch({
            type: 'sale/export',
            data: this.pagerequest
        });
        if (filename != '' && filename != undefined)
            window.location = filename;
    }

    async loadData() {
        if (this.$refs.ind != undefined)
            (this.$refs.ind as any).loadData();
    }

    async loadDates() {
        this.$store.commit('auditlog/setDates', []);
        await this.$store.dispatch({
            type: 'auditlog/getDatesByMonth',
            data: {
                year: this.pagerequest.year,
                dealers: this.dealers,
                model: 'sales',
            }
        });
            
    }

    async processApiSales() {
        await this.$store.dispatch({
            type: 'sale/processApiSales',
            data: {
                year: this.pagerequest.year,
                month: this.pagerequest.month
            }
        });
        await this.getAll();
    }

    async mounted() {
        this.$store.commit('sale/setProcess', this.selProcess);
        await this.loadData();
        await this.loadDates();
    }

    created() {
        this.pagerequest.dealer = this.dealers;
        this.pagerequest.red = this.red;
        this.pagerequest.process_type = this.selProcess;
    }
}